import { json } from '@remix-run/node';
import type { ActionFunctionArgs } from '@remix-run/server-runtime';
import { getConfig, getConfigsCaching } from '~/services/config/index.ts';
import { sessionCookie } from '~/services/session/session.server.ts';
import { getUser } from '~/services/hooks/index.ts';
import { type ClientActionFunctionArgs } from '@remix-run/react';
import {
  getIsRevalidateLoginStateFromRedirect,
  isLoggedInClientState,
} from '~/utils/is-logged-in-client-state';
import { sessionAuthKey } from '~/services/login/session-auth-key';

export async function action({ request }: ActionFunctionArgs) {
  try {
    const { ttl, swr } = getConfigsCaching();
    const {
      layout: { screens },
      pluginConfigurations,
    } = await getConfig({ ttl, swr });

    const { session, commitSession } = await sessionCookie(
      request,
      pluginConfigurations
    );

    const authInfo = await getUser({
      input: { session, screens, pluginConfigurations },
    });

    if (!authInfo) session.set(sessionAuthKey, null);

    return json(
      { isLoggedIn: authInfo?.access_token ? true : false },
      { headers: { 'Set-Cookie': await commitSession() } }
    );
  } catch (error) {
    return json({ isLoggedIn: false });
  }
}

export const clientAction = async ({
  serverAction,
}: ClientActionFunctionArgs) => {
  const isLoggedIn: boolean | null = await isLoggedInClientState().get();
  const isLoggedInStale: boolean = await isLoggedInClientState().isStale();

  if (
    !getIsRevalidateLoginStateFromRedirect() &&
    isLoggedIn !== null &&
    !isLoggedInStale
  )
    return { isLoggedIn };

  const serverActionData: any = await serverAction();

  await isLoggedInClientState().set(!!serverActionData?.isLoggedIn);

  if (isLoggedInStale) await isLoggedInClientState().setRevalidate();

  return serverActionData;
};
